const fadeLoadMore = (btn, value) => {
  if (btn) btn.style.opacity = value
}

const appendAndrevealProducts = (items, grid, skin) => {
  items.forEach((item, index) => {
    const skinimage = item.querySelector(`.skinPickerImage[data-imageskin="${skin}"]`)
    if (skinimage !== null) {
      skinimage.classList.add('--is-active')
    } else {
      const defaultSkin = item.querySelector('.skinPickerImage')
      if (defaultSkin) defaultSkin.classList.add('--is-active')
    }
    item.style.opacity = 0
    grid.appendChild(item)
    setTimeout(() => {
      item.style.opacity = 1
    }, index * 300)
  })
}

const initLoadMore = () => {
  const loadMore = document.querySelector('.loadMore');
  const loadingOverlaySpinner = document.querySelector('.load-more-container .loading-overlay__spinner');

  if (loadMore === null) return
  loadMore.addEventListener('click', e => {
    e.preventDefault()
    const endpoint = loadMore.getAttribute('data-endpoint')
    const collectionName = loadMore.getAttribute('data-collection')
    const searchTerm = loadMore.getAttribute('data-search-term')
    const page = loadMore.getAttribute('data-page')
    const pages = loadMore.getAttribute('data-pages')

    let url;
    if (endpoint === 'collection' || endpoint === 'collections') {
      url = `/collections/${collectionName}?page=${page}&view=loadMore`
    } else if (endpoint === 'search') {
      url = `/search?q=${searchTerm}&page=${page}&view=loadMore`
    }

    fadeLoadMore(loadMore, 0);
    loadingOverlaySpinner.classList.remove('hidden');
    fetch(url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        const items = html.querySelectorAll('.grid__item:not(.grid__item--perfect-shade)');
        const grid = document.querySelector('#product-grid');
        let skin = document.querySelector('#drawer-perfect-shade .sofsy-perfect-shade-picker__item-active');
        if (skin === null) {
          skin = 'default';
        }
        fadeLoadMore(loadMore, 0);
        setTimeout(() => {
          appendAndrevealProducts(items, grid, skin);
          fadeLoadMore(loadMore, 1);
          loadingOverlaySpinner.classList.add('hidden');
          loadMore.setAttribute('data-page', Number(page) + 1);
          loadMore.setAttribute('data-sofsy-track-value', Number(page) + 1) // collection.load_more.tap: the page the next tap loads
          if (Number(page) >= Number(pages)) {
            loadMore.remove();
          }
        }, 500);

      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initLoadMore();
})